import React, { useState } from "react";
import Popup from "../Popup";
import FormHeader from "../form/Header";
import { useTranslation } from "react-i18next";
import { formatDate } from "../../utils/formatDate";
import { CentsToDollars } from "../../utils/formatPrice";
import { validateVoidCard } from "../../api/sell-orders/validateVoidCard";

const VoidCard = ({
  setShowCreateItem,
  selectedForDelete,
  setSelectedForDelete,
  setShowDeleteItem,
}) => {
  const { t } = useTranslation();
  const [cardInfo, setCardInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [prn, setprn] = useState("");
  const [error, seterror] = useState(null);

  const getFullOrder = async () => {
    if (prn) {
      setLoading(true);
      seterror(null);
      setCardInfo(null);
      try {
        const { data } = await validateVoidCard({ prn: prn, details: true });
        setCardInfo(data ?? null);
        seterror(data?.length === 0 ? "Card not found" : null);
      } catch (err) {
        seterror(err?.data?.message ?? err.message);
      }
      setLoading(false);
    }
  };

  return (
    <Popup
      size="large"
      withClose
      withOverlay
      onClose={() => {
        setShowCreateItem(false);
        setCardInfo(null);
        setprn("");
        seterror(null);
      }}
    >
      <FormHeader title={`Void Card`}></FormHeader>
      <p className="mt-2">
        <strong>
          Voiding a card will permanently deactivate it and prevent any future
          use.
        </strong>
      </p>
      <p>
        This action is irreversible and applies only to the selected card. Other
        cards in the same order will remain unaffected.
      </p>
      <div className="d-flex gap-2 align-items-center mt-3">
        <input
          className="form-control"
          type="text"
          name="prn"
          value={prn}
          onChange={(e) => setprn(e.target.value)}
          placeholder="PRN"
        />
        <button
          className="btn btn-primary"
          onClick={() => getFullOrder()}
          disabled={loading}
        >
          {loading ? "Loading..." : "Search"}
        </button>
      </div>

      {loading && <p className="mt-3">{t("Loading card data...")}</p>}

      {error && (
        <p className="text-danger mt-3" style={{ color: "red" }}>
          {error}
        </p>
      )}

      {!loading && cardInfo && (
        <div className="mt-5 b-1">
          <div className="d-flex justify-content-between align-items-center p-2 gap-2 w-100">
            <div>
              <h5 className="mb-1">
                {t("Card Details")}: {prn}
              </h5>
            </div>
            <div>
              {cardInfo.status !== "void_success" && (
                <button
                  type="button"
                  className="btn btn-danger btn-medium"
                  onClick={() => {
                    seterror(null);
                    setSelectedForDelete({
                      ...selectedForDelete,
                      id: cardInfo.id,
                    });
                    setShowDeleteItem(true);
                  }}
                >
                  Void
                </button>
              )}
            </div>
          </div>
          <p>
            {t("Card Id")}: <strong>{cardInfo?.id}</strong>
          </p>
          <p>
            {t("Sell Order Id")}: <strong>{cardInfo?.sell_order_id}</strong>
          </p>
          <p>
            {t("Order Type")}:{" "}
            <strong className="text-uppercase">{cardInfo?.type}</strong>
          </p>
          <p>
            {t("Order Status")}: <strong>{cardInfo?.status}</strong>
          </p>
          <p>
            {t("Load Amount")}:{" "}
            <strong>${CentsToDollars(cardInfo?.load_amount || 0)}</strong>
          </p>
          <p>
            {t("Office Name")}: <strong>{cardInfo?.office_name}</strong>
          </p>
          <p>
            {t("Created date")}:{" "}
            <strong>{formatDate(cardInfo?.created_at)}</strong>
          </p>
        </div>
      )}
    </Popup>
  );
};

export default VoidCard;
